import { Toast } from '@easyvaas/js-components';
import React from 'react';
import { useRecoilValue } from 'recoil';
import SmallText from 'src/components/SmallText';
import { useClosePopup } from '../../hooks/useClosePopup';
import { imagesV3Data, upgradeStar } from '../../services';
import {
  imageItemSelector,
  typedMaterialItemSelector
} from '../../store/selector';
import { imagePopupState } from '../../store/state';
import ImageOpreationPopoup from '../ImageOpreationPopup';
import ImageStars from '../ImageStars';
import styles from './index.module.scss';
const UpgradePopup = () => {
  const { target } = useRecoilValue(imagePopupState('upgrade'));
  const item = useRecoilValue(imageItemSelector(target));
  const material = useRecoilValue(typedMaterialItemSelector(9));
  const close = useClosePopup();
  if (!item || !item.upStar) return null;
  const onClick = async () => {
    try {
      if (!item.upStar) return;
      Toast.loading('请稍等');
      const { data } = await upgradeStar({ imgId: item.id });
      await imagesV3Data.refresh({});
      Toast(`升星${data > item.upStar.level ? '成功' : '失败'}`);
      close('upgrade');
    } catch ({ message }: any) {
      Toast(message);
    }
  };
  return (
    <ImageOpreationPopoup
      type="upgrade"
      title="座驾升星"
      className={styles.container}
      onClick={onClick}
    >
      <img src={item.url} alt="" className={styles.logo} />
      <ImageStars
        count={item.upStar.level}
        size="large"
        className={styles.stars}
      />
      <div className={styles.current}>当前{item.upStar.level}星</div>
      <div className={styles.prob}>
        升{item.upStar.level + 1}星成功率{' '}
        <span>{item.upStar.successRate}%</span>
      </div>
      {material && (
        <div className={styles.block}>
          <SmallText className={styles.label} fontSize={22} inline>
            消耗：
          </SmallText>
          <div
            className={styles.clogo}
            style={{ backgroundImage: `url(${material.logo})` }}
          />
          <div className={styles.info}>
            <SmallText fontSize={22} inline className={styles.text}>
              {material.title}*1
            </SmallText>
            <SmallText fontSize={22} inline className={styles.text}>
              拥有 <span className={styles.accent}>{material.number}</span>
            </SmallText>
          </div>
        </div>
      )}
    </ImageOpreationPopoup>
  );
};

export default React.memo(UpgradePopup);
